import { Component } from "react";
import gsap from "gsap";
import { TweenLite } from "gsap";
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin); // (or in the top-level file in your React app)

class ScrollToTop extends Component {
  tween = null;

  componentDidMount() {
    this.scrollToTop();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.x !== this.props.x || prevProps.y !== this.props.y) {
      console.log('Props updated:', this.props.x, this.props.y);
      this.updateAnimation();
    }
  
  }

  scrollToTop() {
    this.tween = TweenLite.to(window, 0.5, { scrollTo: 0 });
  }

  componentWillUnmount() {
    if (this.tween) this.tween.kill();
  }

  render() {
    return null;
  }
}

export default ScrollToTop;